import AppShellView from './AppShell.view';
export * from './AppShell.view';

export const AppShell = (props) => AppShellView(props);

export default AppShell;

